import { useEffect, useRef } from "react";
import * as React from 'react';
import Swal from "sweetalert2";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useTranslation } from "react-i18next";
import { Box, MenuItem, Input, Select, Chip, FormControlLabel, FormHelperText, Switch, FormControl, InputLabel, Grid } from "@material-ui/core";
import { CompactPicker } from "react-color";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { createStyles, makeStyles, withStyles, useTheme, Theme } from "@material-ui/core/styles";
// import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import ToretaApi from "../../ToretaApi";
import AutocompleteField from "../../Components/AutocompleteField";
import currency from "../../common/Const/currency.json";
import countries from "../../common/Const/countries";
import { TabPanel } from "../../Components";
import { TimeSpanPicker } from "../../Components";
import Timepicker from "../../Components/Timepicker";
import { StripeRestaurant, Course, ShopDetail } from "../../common/interface";
import { emptyLocalized, localizedFromLegacy, pickLocalized, pickLocalizedOrDefault } from "../../common/localizedText";
import i18n from "../../common/i18n";
import { ImageUploadButton } from "../../Components";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import ToggleButton from "@material-ui/lab/ToggleButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import currencyMap from "../../common/Const/currencyMap.json";
import { useSelector } from "react-redux";
import CourseTable from "./CourseTable";
import { useCourseContext } from './CourseContext';
import { validateOpeningHours } from "../../common/openingHours";
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
            maxWidth: 300,
        },
        chips: {
            display: "flex",
            flexWrap: "wrap",
        },
        chip: {
            margin: 2,
        },
        noLabel: {
            marginTop: theme.spacing(3),
        },
        // 表示言語の軽量タブ（上部ページタブとは別実装。下のテキスト項目に対するスコープを示す）
        langTabs: {
            display: "flex",
            gap: 28,
            borderBottom: "1px solid #e3e7ee",
            marginTop: 6,
        },
        langTab: {
            // ブラウザ既定フォントを避け、モーダル全体の MUI フォントを継承させる
            fontFamily: "inherit",
            fontSize: 14,
            fontWeight: 400,
            color: "#5a6472",
            padding: "8px 0",
            marginBottom: -1,
            borderBottom: "2px solid transparent",
            cursor: "pointer",
            userSelect: "none",
            transition: "color 0.15s ease",
            "&:hover": {
                color: "#3f51b5",
            },
        },
        langTabActive: {
            fontWeight: 600,
            color: "#3f51b5",
            borderBottom: "2px solid #3f51b5",
            "&:hover": {
                color: "#3f51b5",
            },
        },
    })
);

const StyledTableCell = withStyles((theme: Theme) => ({
    root:{
        border: "none",
        padding: "8px"
    }
}))(TableCell);

const HoursTableCell = withStyles((theme: Theme) => ({
    root: {
        borderBottom: "1px solid rgba(0,0,0,.12)",
        padding: "9px 12px"
    },
    head: {
        color: "rgba(0,0,0,.54)",
        fontSize: 12,
        fontWeight: 500
    }
}))(TableCell);

const StyledToggleButtonGroup = withStyles((theme: Theme) => ({
    grouped: {
        color: 'white',
        backgroundColor: '#3f51b5a3',
        "&.MuiToggleButton-root:hover": {
            color: "white",
            backgroundColor: '#3f51b5a3'
        },
        "&.Mui-selected, &.Mui-selected:hover": {
            color: "white",
            backgroundColor: '#3f51b5'
        },
    },
}))(ToggleButtonGroup);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};
function getStyles(restaurant: Course, restaurantsIds: string[], theme: Theme) {
    return {
        fontWeight: restaurantsIds.find((a) => a === restaurant.id) ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium,
    };
}


type Props = {
    open: boolean;
    data: StripeRestaurant | null;
    close: () => void;
    search: () => void;
};
interface DialogStripeRestaurant extends StripeRestaurant {
    restaurantLink?:string | "";
    file?: File | null;
}
const defaultga = () => {
    return { type: "GTM", code: "" };
};
const JAPAN_COMPANY_CODE:string='jp';
const defaultValue: DialogStripeRestaurant = {
    publicKey: "",
    restaurantLink: "",
    PK: "",
    SK: "",
    ga: defaultga(),
    email: "",
    enabled: true,
    // 新規店舗の初期値は ON（デビット拒否）。既存店舗は API が false を返すため上書きされ OFF になる。
    rejectDebitCards: true,
    currency: "",
    country: "",
    color: "",
    needTable: true,
    tableInfo: "",
    address: "",
    cancellationPolicy: emptyLocalized(),
    needCourse: true,
    needNote: null,
    courseInfo: emptyLocalized(),
    depositExplanation: null,   // null = 未編集（マイグレーション直後）→ i18nデフォルトにフォールバック
    openinghours: [
        { weekday: "0", lunch_start: 0, lunch_end: 0, lunch_cutoff: 0, dinner_end:0, dinner_start:0, dinner_cutoff:0},
        { weekday: "1", lunch_start: 0, lunch_end: 0, lunch_cutoff: 0, dinner_end:0, dinner_start:0, dinner_cutoff:0},
        { weekday: "2", lunch_start: 0, lunch_end: 0, lunch_cutoff: 0, dinner_end:0, dinner_start:0, dinner_cutoff:0},
        { weekday: "3", lunch_start: 0, lunch_end: 0, lunch_cutoff: 0, dinner_end:0, dinner_start:0, dinner_cutoff:0},
        { weekday: "4", lunch_start: 0, lunch_end: 0, lunch_cutoff: 0, dinner_end:0, dinner_start:0, dinner_cutoff:0},
        { weekday: "5", lunch_start: 0, lunch_end: 0, lunch_cutoff: 0, dinner_end:0, dinner_start:0, dinner_cutoff:0},
        { weekday: "6", lunch_start: 0, lunch_end: 0, lunch_cutoff: 0, dinner_end:0, dinner_start:0, dinner_cutoff:0},
    ],
    name: "",
    file: null,
    picture: "",
    onCourse: [],
    courses:[],
    isMultiMealCourse: false,
    isMultiNumberOfPerson: false
    // homepage: "",
};

const FormDialog: React.FunctionComponent<Props> = ({ open, data, close, search }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const weeks = [ 'SUN','MON','TUE', 'WED', 'THU' , 'FRI' , 'SAT' ];
    const openingHoursRef = useRef<HTMLDivElement>(null);
    const user: any = useSelector((state: any) => state.user);
    const { settingCourselist,updateCourselist } = useCourseContext();
    //console.log(courseSettingList); 
    const [selectedJapanCountry,SetJapanCountry] = React.useState<any>(false);
    const currencyList = React.useMemo(() => {
        
        const useCurrency: any = currency;
        const result = [];
        for (let key in useCurrency) {
            const obj = useCurrency[key];
            result.push({
                value: obj.code,
                label: `${obj.symbol} / ${obj.name} / ${obj.code}`,
            });
        }
        return result;
        // eslint-disable-next-line
    }, [currency]);
    const currencyMapList = () => {
        const useCurrency: any =  currency;
        const useCurrencyMap: any = currencyMap;
        const result = [];
        for (let key in useCurrencyMap) {
            const currencyCodes = useCurrencyMap[key];
            for (let index = 0; index < currencyCodes.length; index++) {
                const currencyCode = currencyCodes[index];
                const currencyInfo=useCurrency[currencyCode];
                result.push({
                    countryCode:key,
                    value: currencyCode,
                    label: `${currencyInfo.symbol} / ${currencyInfo.name} / ${currencyInfo.code}`,
                });

            } 
        }
        
        var lst= result.filter((x)=>{return x.countryCode==form.country;});
        if(lst.length>0){
            var currVal= lst.filter((x)=>{return x.value==form.currency;});
            if(currVal.length>0){
                form.currency=currVal[0].value;
            }else{
                form.currency=lst[0].value;
            }
        }
        return lst;
        // eslint-disable-next-line
    };
    //const shop: ShopDetail = useSelector((state: any) => state.shop);
    const toretaApi = ToretaApi();
    const { isManageLevel } = toretaApi;
    const { isAdmin } = toretaApi;
    const theme = useTheme();
    const [form, setForm] = React.useState<DialogStripeRestaurant>(defaultValue);
    const [textLang, setTextLang] = React.useState<string>("ja");      // 多言語セクションの表示言語
    const [noticeEditing, setNoticeEditing] = React.useState<boolean>(false); // γ：注意文の編集モード
    const [tabIndex, setTabIndex] = React.useState(0);
    const [courseList, setCourseList] = React.useState<Course[]>([]);
    const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setTabIndex(newValue);
    };
    const handleCourseChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        setForm({ ...form, onCourse: event.target.value as string[] });
    };
    // 指定言語の注意文デフォルト（現行i18n）を取得
    const noticeDefaultFor = (lng: string) =>
        i18n.t("RESERVE_CONFIRMATION.DEPOSIT_EXPLANATION_JP", { lng }) as string;
    // 注意文の表示値（プレビュー / 編集フィールド共通）。
    // 未設定(null/キー無し)→i18nデフォルト、""→空のまま、値→その値。
    const noticeEffective = (lng: string) => pickLocalizedOrDefault(form.depositExplanation, lng, noticeDefaultFor(lng));
    const setLocalizedField = (field: "courseInfo" | "cancellationPolicy" | "depositExplanation", lng: string, value: string) => {
        setForm({ ...form, [field]: { ...(form[field] as any), [lng]: value } });
    };
    // 注意文を「初期文言（i18nデフォルト）」へ戻す = 該当言語のカスタム値を“未設定”に戻す。
    // literal を保存すると将来 i18n が変わっても追従できないため、キー自体を削除する。
    // 全言語が未設定になったら depositExplanation 全体を null（= 完全未編集）に戻す。
    const resetNoticeToDefault = (lng: string) => {
        const cur = form.depositExplanation;
        if (cur == null) return; // 既に未設定（=デフォルト表示）なら何もしない
        const next: any = { ...(cur as any) };
        delete next[lng];
        const isEmpty = Object.keys(next).length === 0;
        setForm({ ...form, depositExplanation: isEmpty ? null : next });
    };
    
    useEffect(() => {       
        //console.log(courseList);
        if (data !== null) {
            //console.log("data",data);
            toretaApi.GetShopOther(data.publicKey);
            toretaApi.getShopFullCourses(data.publicKey).then((coursedatas) => {
                toretaApi.getRestaurantLink(data.publicKey).then( (restaurantLink)=> {
                    // 取得成功時のみ有効なコース一覧として扱う（失敗時 undefined は空扱いにせず onCourse を触らない）
                    const fetchSucceeded = Array.isArray(coursedatas);
                    const availableCourses = fetchSucceeded ? coursedatas : [];
                    const savedOnCourse = data.onCourse ? data.onCourse : [];
                    // トレタ管理側で削除されたコースの id が onCourse に残ると、名前解決できず
                    // 「空白グレーの Chip」として表示され、プルダウンからも消せなくなる（tech-support #1078）。
                    // 取得に成功した場合のみ、現存するコースの id だけに絞り込む（次回保存で DB 上も掃除される）。
                    const onCourse = fetchSucceeded
                        ? savedOnCourse.filter((id) => availableCourses.some((c) => c.id === id))
                        : savedOnCourse;
                    const newform = { ...defaultValue, ...data,
                        onCourse: onCourse, file: null ,
                        restaurantLink: restaurantLink };
                    if (!newform.ga) {
                        newform.ga = defaultga();
                    }
                    // 多言語テキストを正規化（レガシー単一文字列 / null を4言語マップへ）
                    newform.courseInfo = typeof data.courseInfo === "string"
                        ? localizedFromLegacy(data.courseInfo)
                        : (data.courseInfo ?? emptyLocalized());
                    newform.cancellationPolicy = typeof data.cancellationPolicy === "string"
                        ? localizedFromLegacy(data.cancellationPolicy)
                        : (data.cancellationPolicy ?? emptyLocalized());
                    // depositExplanation は null と "" を区別するため、null は正規化せずそのまま保持。
                    // （null=未編集→i18nデフォルト、{lang:""}=意図的な空欄）
                    newform.depositExplanation = data.depositExplanation ?? null;
                    setForm(newform);
                    setCourseList(availableCourses);
                });
            });
            //console.log('getShopSettingCourses');
            toretaApi.getShopSettingCourses(data.publicKey,(data.id==null?0:data.id)).then( (courses)=> {   
                const hasDeletedCourse = courses.some(item => item.course_name === null || item.course_name === ''); 
                if(hasDeletedCourse){
                    courses = courses.filter(item => item.course_name !== null && item.course_name !== '');
                }
                updateCourselist(courses);
            });
        }
        SetJapanCountry((user.admin? user.select_country==JAPAN_COMPANY_CODE: user.company_country==JAPAN_COMPANY_CODE));
        // eslint-disable-next-line
    }, [data]);
    
    const updateData = () => {
        //TODO: ValidateEmail
        const IsBlank = (value: string) => {
            return !value || value === undefined || value === "";
        };
        // 営業時間タブ 層1: DOM の形式検証（react-time-picker は不正値で onChange を出さないため直接見る）
        const openingHoursInputs = openingHoursRef.current?.querySelectorAll<HTMLInputElement>("input[data-input]") ?? [];
        const hasInvalidOpeningHoursInput = Array.from(openingHoursInputs).some(
            (el) => !el.checkValidity() || el.value === ""
        );
        if (hasInvalidOpeningHoursInput) {
            Swal.fire({
                icon: "error",
                title: t("MANAGER.ERRORMESSAGE.OPENINGHOURS-001"),
            });
            setTabIndex(3);
            return;
        }
        // 営業時間タブ 層2: form 状態の形式検証（秒数が 0〜86399 の整数か。API 側と同じ純関数）
        const openingHoursError = validateOpeningHours(form.openinghours);
        if (openingHoursError) {
            Swal.fire({
                icon: "error",
                title: t("MANAGER.ERRORMESSAGE." + openingHoursError.code),
            });
            setTabIndex(3);
            return;
        }
        // SK/PK は必須ではない（Stripe を使わない店舗もあるため）。
        // デビットカード拒否 ON 時のキー検証:
        //  - admin（納品する運用者）は検証免除。ダミーキーのまま納品させるので形式チェックもしない。
        //  - 非 admin（顧客）のみ形式チェックで即時フィードバック。疎通（実在性）はサーバ側で行い、
        //    失敗時 PAYMENTSETTING-006 を errorHandle が表示する。
        if (form.rejectDebitCards && !isAdmin) {
            const isStripeKeyFormat = (value: string, prefix: string) =>
                new RegExp(`^${prefix}_(test|live)_`).test((value || "").trim());
            if (!isStripeKeyFormat(form.SK, "sk") || !isStripeKeyFormat(form.PK, "pk")) {
                Swal.fire({
                    icon: "error",
                    title: t("MANAGER.ERRORMESSAGE.PAYMENTSETTING-005"),
                });
                return;
            }
        }
        if (IsBlank(form.currency)) {
            Swal.fire({
                icon: "error",
                title: t("MANAGER.ERRORMESSAGE.PAYMENTSETTING-003"),
            });
            return;
        } else if (IsBlank(form.country)) {
            Swal.fire({
                icon: "error",
                title: t("MANAGER.ERRORMESSAGE.PAYMENTSETTING-004"),
            });
            return;
        } else {
            const successAction = () => {
                search();
                close();
            };
            const sendform = { ...form };
            delete sendform["file"];
            sendform.courses = settingCourselist;  
            toretaApi.updateRestaurantStripe(sendform, form.file ?? null, successAction);
        }
    };
    const fileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target && event.target.files) {
            setForm({ ...form, file: event.target.files[0] });
        }
    };
    const clickOpenButton = () => {
        
        window.open(form.restaurantLink);
        
    };

  const handleNeedCourseChange = (
    event: React.MouseEvent<HTMLElement>,
    newOption: boolean | null,
  ) => {
      setForm({ ...form, needCourse: newOption });
  };

  const handleNeedNoteChange = (
    event: React.MouseEvent<HTMLElement>,
    newOption: boolean | null,
  ) => {
      setForm({ ...form, needNote: newOption });
  };

    return ( 
        <Box>
            <Dialog open={open} className="paymentDialogWidth" fullWidth={true} onClose={close} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">
                    {`${form.name} `}
                    {/* {isManageLevel ? t("MANAGER.ACTION.EDIT") : t("MANAGER.ACTION.READONLY")} */}
                </DialogTitle>
                <DialogContent>
                    <AppBar position="static" color="default">
                        <Tabs value={tabIndex} onChange={handleTabChange} indicatorColor="primary" textColor="primary" variant="fullWidth" aria-label="full width tabs example">
                            <Tab label={t("MANAGER.TAB.RESTAURANTINFO")} id={`full-width-tab-0`} aria-controls={`full-width-tabpanel-0`} />
                            <Tab label={t("MANAGER.TAB.COURSE")} id={`full-width-tab-3`} aria-controls={`full-width-tabpanel-0`} />
                            <Tab label={t("MANAGER.TAB.PAYMENT")} id={`full-width-tab-1`} aria-controls={`full-width-tabpanel-0`} />
                            <Tab label={t("MANAGER.TAB.OPENINGHOURS")} id={`full-width-tab-2`} aria-controls={`full-width-tabpanel-0`} />
                        </Tabs>
                    </AppBar>
                    <TabPanel value={tabIndex} index={0} dir={theme.direction}>
                        <Box p={1}>
                                <Button variant="contained" color="primary" onClick={clickOpenButton}>
                                {t("MANAGER.ACTION.OPEN_RESTAURANT")}
                                </Button>
                        </Box>
                        <Box p={1}>
                            {t("MANAGER.FIELD.APP_BAR_COLOR")}
                            <p />
                            <CompactPicker
                                color={form.color}
                                onChangeComplete={(value: any) => {
                                    setForm({ ...form, color: value.hex });
                                }}
                            />
                        </Box>
                        <Box p={1}>
                            <TextField
                                label={t("MANAGER.FIELD.PIC")}
                                type="text"
                                value={form.picture}
                                fullWidth
                                onChange={(event) => {
                                    setForm({ ...form, picture: event.target.value });
                                }}
                            />
                        </Box>
                        <Box p={1}>
                            <ImageUploadButton fileChange={fileChange} file={form.file ?? null} />
                        </Box>
                        <Box p={1}>
                            <AutocompleteField
                                label={t("MANAGER.FIELD.COUNTRY")}
                                variant={"standard"}
                                optionList={countries}
                                value={form.country}
                                onChange={(value: any) => {
                                    setForm({ ...form, country: value });
                                }}
                            />
                        </Box>
                        <Box p={1}>
                            <TextField
                                // label={t("MANAGER.FIELD.TABLE_INFO")}
                                label={t("ADDRESS")}
                                type="text"
                                multiline
                                placeholder="Enter Address"
                                variant="standard"
                                value={form.address}
                                fullWidth
                                inputProps={{ maxLength: 255}}
                                onChange={(event) => {
                                    setForm({ ...form, address: event.target.value });
                                }}
                            />
                        </Box>
                        <Box p={1}>
                            <FormControl fullWidth>
                                <InputLabel>{t("COURSE")}</InputLabel>
                                <Select
                                    label={t("COURSE")}
                                    multiple
                                    fullWidth
                                    value={form.onCourse}
                                    onChange={handleCourseChange}
                                    input={<Input />}
                                    renderValue={(selected) => (
                                        <div className={classes.chips}>
                                            {(selected as string[]).map((value) => {
                                                const label = courseList.find((a) => a.id === value)?.name;
                                                return <Chip key={value} label={label} className={classes.chip} />;
                                            })}
                                        </div>
                                    )}
                                    MenuProps={MenuProps}
                                >
                                    {courseList.map((course) => (
                                        <MenuItem key={course.id} value={course.id} style={getStyles(course, form.onCourse || [], theme)}>
                                            {course.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                        <Box p={1}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={form.needTable}
                                        color="primary"
                                        onChange={(event) => {
                                            setForm({ ...form, needTable: event.target.checked });
                                        }}
                                        inputProps={{ "aria-label": "secondary checkbox" }}
                                    />
                                }
                                label={t("MANAGER.FIELD.NEED_TABLE")}
                                labelPlacement="start"
                            />
                        </Box>
                        <Box p={1}>
                            <TextField
                                label={t("MANAGER.FIELD.TABLE_INFO")}
                                type="text"
                                multiline
                                rows={4}
                                variant="outlined"
                                value={form.tableInfo}
                                fullWidth
                                onChange={(event) => {
                                    setForm({ ...form, tableInfo: event.target.value });
                                }}
                            />
                        </Box>
                        <Box p={1}>
                            <FormControlLabel
                                control={
                                    <StyledToggleButtonGroup
                                        size="small"
                                        value={form.needCourse}
                                        exclusive
                                        onChange={handleNeedCourseChange}
                                        >
                                        <ToggleButton value={false}>OFF</ToggleButton>
                                        <ToggleButton value={true}>ON</ToggleButton>
                                        <ToggleButton value={null}>OPTION</ToggleButton>
                                        </StyledToggleButtonGroup>
                                }
                                label={t("MANAGER.FIELD.NEED_COURSE") + "　"}
                                labelPlacement="start"

                            />
                        </Box>
                        <Box p={1}>
                            <FormControlLabel
                                control={
                                    <StyledToggleButtonGroup
                                        size="small"
                                        value={form.needNote}
                                        exclusive
                                        onChange={handleNeedNoteChange}
                                        >
                                        <ToggleButton value={false}>OFF</ToggleButton>
                                        <ToggleButton value={true}>ON</ToggleButton>
                                        <ToggleButton value={null}>OPTION</ToggleButton>
                                        </StyledToggleButtonGroup>
                                }
                                label={t("MANAGER.FIELD.NEED_NOTE") + "　"}
                                labelPlacement="start"
                            />
                        </Box>
                        <Box p={1}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={form.isMultiMealCourse}
                                        color="primary"
                                        onChange={(event) => {
                                            setForm({ ...form, isMultiMealCourse: event.target.checked });
                                        }}
                                        inputProps={{ "aria-label": "secondary checkbox" }}
                                    />
                                }
                                label={t("MANAGER.FIELD.MULTI_MEAL_COURSE")}
                                labelPlacement="start"
                            />
                        </Box>
                        <Box p={1}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={form.isMultiNumberOfPerson}
                                        color="primary"
                                        onChange={(event) => {
                                            setForm({ ...form, isMultiNumberOfPerson: event.target.checked });
                                        }}
                                        inputProps={{ "aria-label": "secondary checkbox" }}
                                    />
                                }
                                label={t("MANAGER.FIELD.NULTI_NUMBER_OF_PERSON")}
                                labelPlacement="start"
                            />
                        </Box>
                        {/* ===== 顧客向け表示テキスト群（コース/注意文/ポリシーを共通言語タブで切替） ===== */}
                        <Box p={2} mt={1} style={{ border: "1px solid #e3e7ee", borderRadius: 8 }}>
                            {/* 言語切替：下のテキスト項目に効くスコープを示す軽量の下線タブ */}
                            <Box className={classes.langTabs}>
                                {[
                                    { value: "ja", label: "日本語" },
                                    { value: "en", label: "English" },
                                    { value: "zh-TW", label: "繁中" },
                                    { value: "vi", label: "Tiếng Việt" },
                                ].map((lang) => (
                                    <Box
                                        key={lang.value}
                                        role="tab"
                                        aria-selected={textLang === lang.value}
                                        className={`${classes.langTab} ${textLang === lang.value ? classes.langTabActive : ""}`}
                                        onClick={() => { setTextLang(lang.value); setNoticeEditing(false); }}
                                    >
                                        {lang.label}
                                    </Box>
                                ))}
                            </Box>

                            {/* コースメニュー（全店共通・多言語） */}
                            <Box mt={3}>
                                {/* 与信と同様、ラベルは枠の外（上）に固定表示する */}
                                <Box fontSize={13} mb={1}>{t("MANAGER.FIELD.COURSE_INFO")}</Box>
                                <TextField
                                    type="text" multiline rows={4} variant="outlined" fullWidth
                                    value={pickLocalized(form.courseInfo, textLang, "")}
                                    onChange={(e) => setLocalizedField("courseInfo", textLang, e.target.value)}
                                />
                            </Box>

                            {/* 与信・キャンセル注意文（日本店舗のみ・γ：プレビュー＋編集） */}
                            {selectedJapanCountry === true ? (
                                <Box mt={3}>
                                    {!noticeEditing ? (
                                        <Box>
                                            <Box fontSize={13} mb={1}>
                                                {t("MANAGER.FIELD.NOTICE_TITLE")}
                                                <Box component="span" fontSize={12} color="#8a909c" ml={0.5}>
                                                    {t("MANAGER.FIELD.NOTICE_EDIT_HINT")}
                                                </Box>
                                            </Box>
                                            <Box p={1.5} style={{ border: "1px solid #e3e7ee", borderRadius: 6, background: "#f7f9fb", fontSize: 12, whiteSpace: "pre-wrap", height: 180, overflow: "auto" }}>
                                                {noticeEffective(textLang)}
                                            </Box>
                                            <Box textAlign="right" mt={1}>
                                                <Button size="small" variant="outlined" onClick={() => setNoticeEditing(true)}>
                                                    {t("MANAGER.FIELD.NOTICE_EDIT")}
                                                </Button>
                                            </Box>
                                        </Box>
                                    ) : (
                                        <Box>
                                            {/* プレビューと同じ位置の固定ラベル。編集モードでもタイトルが動かないよう label prop は使わない */}
                                            <Box fontSize={13} mb={1}>{t("MANAGER.FIELD.NOTICE_TITLE")}</Box>
                                            <TextField
                                                type="text" multiline rows={8} variant="outlined" fullWidth
                                                // カスタム未保存なら言語ファイルのデフォルト文を初期表示（そこから一部削除等を可能に）。
                                                // 未編集のまま OK すれば form は空のままなので保存時は null → i18nフォールバックを維持する。
                                                value={noticeEffective(textLang)}
                                                onChange={(e) => setLocalizedField("depositExplanation", textLang, e.target.value)}
                                            />
                                            <Box display="flex" justifyContent="space-between" mt={1}>
                                                <Button size="small" onClick={() => resetNoticeToDefault(textLang)}>
                                                    {t("MANAGER.FIELD.NOTICE_RESET_DEFAULT")}
                                                </Button>
                                                <Button size="small" variant="contained" color="primary" onClick={() => setNoticeEditing(false)}>
                                                    OK
                                                </Button>
                                            </Box>
                                        </Box>
                                    )}
                                </Box>
                            ) : null}

                            {/* キャンセルポリシー（日本店舗のみ・多言語） */}
                            {selectedJapanCountry === true ? (
                                <Box mt={3}>
                                    {/* 与信と同様、ラベルは枠の外（上）に固定表示する */}
                                    <Box fontSize={13} mb={1}>{t("CANCELLATION_POLICY")}</Box>
                                    <TextField
                                        type="text" multiline rows={4} placeholder="Cancellation policy" variant="outlined" fullWidth
                                        inputProps={{ maxLength: 10000 }}
                                        value={pickLocalized(form.cancellationPolicy, textLang, "")}
                                        onChange={(e) => setLocalizedField("cancellationPolicy", textLang, e.target.value)}
                                    />
                                </Box>
                            ) : null}
                        </Box>

                        <Box p={1} mt={4}>
                            <Grid container>
                                <Grid xs={4} item>
                                    <FormControl fullWidth>
                                        <InputLabel>{t("MANAGER.FIELD.GA_TYPE")}</InputLabel>
                                        <Select
                                            label={t("MANAGER.FIELD.GA_TYPE")}
                                            fullWidth
                                            value={form.ga?.type}
                                            onChange={(event: React.ChangeEvent<{ value: unknown }>) => {
                                                const ga = {
                                                    code: "",
                                                    ...form.ga,
                                                    type: event.target.value as string,
                                                };
                                                setForm({ ...form, ga });
                                            }}
                                            input={<Input />}
                                            MenuProps={MenuProps}
                                        >
                                            <MenuItem key={"GTM"} value={"GTM"}>
                                                GTM
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        label={t("MANAGER.FIELD.GA_CODE")}
                                        type="text"
                                        value={form.ga?.code}
                                        fullWidth
                                        onChange={(event) => {
                                            const ga = {
                                                type: "GTM",
                                                ...form.ga,
                                                code: event.target.value,
                                            };
                                            setForm({ ...form, ga });
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        label={t("MANAGER.FIELD.SHOP_EMAIL")}
                                        type="text"
                                        value={form.email}
                                        fullWidth
                                        onChange={(event) => {
                                            setForm({ ...form, email: event.target.value });
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                        {/* <Box p={1}>
                            <TextField
                                label={t("MANAGER.FIELD.HOMEPAGE")}
                                type="text"
                                multiline
                                rows={4}
                                variant="outlined"
                                value={form.homepage ? form.homepage : shop.homepage}
                                fullWidth
                                onChange={(event) => {
                                    setForm({ ...form, homepage: event.target.value });
                                }}
                            />
                        </Box> */}
                    </TabPanel>

                    <TabPanel value={tabIndex} index={1}>
                        <Box className="course-list" >
                        <CourseTable data={data} />
                        </Box>
                    </TabPanel>

                    <TabPanel value={tabIndex} index={2} dir={theme.direction}>
                        <Box p={1}>
                            <AutocompleteField
                                label={t("MANAGER.FIELD.CURRENCY")}
                                variant={"standard"}
                                optionList={currencyMapList()}
                                value={form.currency}
                                onChange={(value: any) => {
                                    setForm({ ...form, currency: value });
                                }}
                            />
                        </Box>
                        {isManageLevel ? (
                            <>
                                <Box p={1}>
                                    <TextField
                                        label={t("MANAGER.FIELD.STRIPE_SK")}
                                        type="text"
                                        value={form.SK}
                                        fullWidth
                                        onChange={(event) => {
                                            setForm({ ...form, SK: event.target.value });
                                        }}
                                    />
                                </Box>
                                <Box p={1}>
                                    <TextField
                                        label={t("MANAGER.FIELD.STRIPE_PK")}
                                        type="text"
                                        value={form.PK}
                                        fullWidth
                                        onChange={(event) => {
                                            setForm({ ...form, PK: event.target.value });
                                        }}
                                    />
                                </Box>
                                <Box p={1}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={!!form.rejectDebitCards}
                                                color="primary"
                                                onChange={(event) => {
                                                    setForm({ ...form, rejectDebitCards: event.target.checked });
                                                }}
                                                inputProps={{ "aria-label": "reject debit card" }}
                                            />
                                        }
                                        label={t("MANAGER.FIELD.REJECT_DEBIT_CARD")}
                                    />
                                    <FormHelperText>
                                        {t("MANAGER.FIELD.REJECT_DEBIT_CARD_HELP")}
                                    </FormHelperText>
                                </Box>
                            </>
                        ) : null}
                        {isAdmin ? (
                            <>
                        <Box p={1}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={form.enabled}
                                        color="primary"
                                        onChange={(event) => {
                                            setForm({ ...form, enabled: event.target.checked });
                                        }}
                                        inputProps={{ "aria-label": "secondary checkbox" }}
                                    />
                                }
                                label={t("MANAGER.STATUS.ENABLED")}
                            />
                        </Box>
                            </>
                        ) : null}
                    </TabPanel>
                    <TabPanel value={tabIndex} index={3} dir={theme.direction}>
                        <Box p={1}>
                            <TableContainer ref={openingHoursRef}>
                                <Table aria-label="opening hours table">
                                    <TableHead>
                                        <TableRow>
                                            <HoursTableCell style={{ width: 52 }} />
                                            <HoursTableCell>{t("MANAGER.OPENINGHOURS.LUNCH")}</HoursTableCell>
                                            <HoursTableCell>{t("MANAGER.OPENINGHOURS.DINNER")}</HoursTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {weeks.map((week: any , weekIdx: number) => {
                                        return (
                                        <TableRow key={weekIdx}>
                                            <HoursTableCell>{t(week)}</HoursTableCell>
                                            <HoursTableCell>
                                            <TimeSpanPicker
                                            start_time={form.openinghours[weekIdx].lunch_start}
                                            end_time={form.openinghours[weekIdx].lunch_end}
                                            onStartTimeChange={(pickedTime: number)=>{
                                                form.openinghours[weekIdx].lunch_start = pickedTime;
                                                setForm({ ...form});
                                            }}
                                            onEndTimeChange={(pickedTime: number)=>{
                                                form.openinghours[weekIdx].lunch_end = pickedTime;
                                                setForm({ ...form});
                                            }} />
                                            {/* <Timepicker
                                                time={form.openinghours[weekIdx].lunch_cutoff}
                                                onTimeChange={(pickedTime: number)=>{
                                                    form.openinghours[weekIdx].lunch_cutoff = pickedTime;
                                                    setForm({ ...form});
                                                }}
                                            /> */}
                                            </HoursTableCell>
                                            <HoursTableCell>
                                            <TimeSpanPicker
                                            start_time={form.openinghours[weekIdx].dinner_start}
                                            end_time={form.openinghours[weekIdx].dinner_end}
                                            onStartTimeChange={(pickedTime: number)=>{
                                                form.openinghours[weekIdx].dinner_start = pickedTime;
                                                setForm({ ...form});
                                            }}
                                            onEndTimeChange={(pickedTime: number)=>{
                                                form.openinghours[weekIdx].dinner_end = pickedTime;
                                                setForm({ ...form});
                                            }} />
                                            {/* <Timepicker
                                                time={form.openinghours[weekIdx].dinner_cutoff}
                                                onTimeChange={(pickedTime: number)=>{
                                                    form.openinghours[weekIdx].dinner_cutoff = pickedTime;
                                                    setForm({ ...form});
                                                }}
                                            /> */}
                                            </HoursTableCell>
                                        </TableRow>
                                        );
                                    })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </TabPanel>
                </DialogContent>
                <DialogActions className={"tab-"+tabIndex}>
                    {tabIndex==1?(
                    <Box className="course-list-note">
                        <div>
                        {t('MANAGER.COURSE.NOTE')}
                        </div>
                        </Box>
                    ):(<></>)
                    }
                    <Button onClick={close} color="secondary">
                        {t("MANAGER.ACTION.CANCEL")}
                    </Button>
                    {isManageLevel ? (
                        <Button onClick={updateData} color="primary">
                             {tabIndex==1?t("MANAGER.ACTION.SAVE"):t("MANAGER.ACTION.OK")}
                        </Button>
                    ) : null}
                </DialogActions>
            </Dialog>
        </Box>
    );
};
export default FormDialog;
